(function($) {
  var once = false;
  Drupal.behaviors.languageSwitcher = {
    attach: function attach(context, settings) {
      var $topbarSwitcher = $("#block-languageswitcher");
      if ($topbarSwitcher.length == 0 || once) return;
      once = true;

      var $options = $topbarSwitcher.find(".dropdown-menu li").map((i, li) => {
        var $a = $(li).find("a");
        return {
          label: $a.text(),
          href: $a.attr("href"),
          hreflang: $a.attr("hreflang")
        };
      });

      var activeLabel = $topbarSwitcher
        .find(".dropdown-toggle")
        .text()
        .trim();

      var $menuItem = $(
        ".mobile-menu-pane #block-mobilemenu .menu.nav .lvl-0"
      ).filter((i, item) => {
        return (
          $(item)
            .text()
            .trim() == "language_switch"
        );
      });
      $menuItem.find("*").remove();

      var $collapseLabel = $('<div class="dropdown-toggle"></div>')
        .attr({
          "data-toggle": "collapse",
          "data-target": "#mobile-menu-language-switcher"
        })
        .text(activeLabel)
        .append(
          '<img class="chevron-down" src="https://www.onespan.com/themes/custom/onespan/images/icons/chevron-select.svg" width="8" height="8" alt=""/>'
        );

      var $collapseList = $(
        '<ul class="collapse" id="mobile-menu-language-switcher">'
      ).attr({
        "aria-expanded": "false"
      });

      $options.each((i, option) => {
        var $li = $('<li class="lvl-1">');
        var $a = $('<a class="language-link">')
          .attr({
            href: option.href,
            hreflang: option.hreflang
          })
          .text(option.label);

        $li.append($a);
        $collapseList.append($li);
      });

      $menuItem.append($collapseLabel);
      $menuItem.append($collapseList);

      $(".mobile-menu-pane #block-mobilemenu .menu.nav").append($menuItem);
    }
  };
})(jQuery);
